import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import API from '../../services/api.js';
import LoadingPopup from '../misc/Loading.js';

const Datasets = () => {
  const navigate = useNavigate();
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const selectedApp = sessionStorage.getItem("selectedApp")

  const handleRerun = async (configurationName) => {
    try {
      const response = await API.post(`${process.env.REACT_APP_DJANGO_API_URL}/rerun-config/`, {
        configuration_name: configurationName,
        selectedApp: selectedApp,
      });
      console.log('targetdata', response.data.targetData);
      sessionStorage.setItem('targetData', JSON.stringify(response.data.targetData));
      sessionStorage.setItem('selectedDetectors', JSON.stringify(response.data.selectedDetectors));
      sessionStorage.setItem('selectedMethods', JSON.stringify(response.data.selectedMethods));
      sessionStorage.setItem('customStrategies', JSON.stringify(response.data.customStrategies || {}));
      sessionStorage.setItem('customPrompts', JSON.stringify(response.data.customPrompts || []));
      sessionStorage.setItem("savedScanDepth", JSON.stringify(response.data.scanDepth))
      sessionStorage.setItem("description", JSON.stringify(response.data.description))
      sessionStorage.setItem("customDetectors", JSON.stringify(response.data.customDetectors));
      sessionStorage.setItem("savedConcurrency", JSON.stringify(response.data.concurrency ?? 15));

      navigate("/newscan");
    } catch (err) {
      console.error(`Failed to trigger re-run for ${configurationName}`, err);
    }
  };

  useEffect(() => {
    const fetchProjects = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await API.post(`${process.env.REACT_APP_DJANGO_API_URL}/yaml-configs/`,{"selectedApp":selectedApp});
        setProjects(response.data);
      } catch (err) {
        setError('Failed to fetch project data');
      } finally {
        setLoading(false);
      }
    };

    fetchProjects();
  }, [selectedApp]);

  return (
    <div className="p-6 sm:p-8 text-white min-h-screen">

      {/* Page header */}
      <div className="mb-8">
        <p className="text-white font-bold text-3xl">Configuration Files</p>
        <p className="text-gray-400 text-sm mt-1">Saved scan configurations for re-running previous setups</p>
      </div>

      {loading ? (
        <LoadingPopup isVisible={true}/>
      ) : error ? (
        <div className="bg-[#101012] border border-[#232325] rounded-2xl p-12 flex flex-col items-center justify-center text-center">
          <svg className="w-10 h-10 text-gray-600 mb-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 9v2m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <p className="text-red-400 text-sm">{error}</p>
        </div>
      ) : (
        <div className="bg-[#101012] border border-[#232325] rounded-2xl overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-white min-w-[480px]">
              <thead>
                <tr className="bg-[#232325]">
                  <th className="px-4 py-3 font-medium text-gray-400 text-sm text-left whitespace-nowrap">Configuration Name</th>
                  <th className="px-4 py-3 font-medium text-gray-400 text-sm text-left whitespace-nowrap">Time Created</th>
                  <th className="px-4 py-3 font-medium text-gray-400 text-sm text-left whitespace-nowrap">Action</th>
                </tr>
              </thead>
              <tbody>
                {Array.isArray(projects) && projects.length > 0 ? (
                  projects.map((project, index) => (
                    <tr key={index} className="border-t border-[#232325] hover:bg-[#1a1a1c] transition-colors">
                      <td className="px-4 py-3 text-sm text-gray-200 whitespace-nowrap">
                        {project.configuration_name.split('.yaml')[0]}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-400 whitespace-nowrap">{project.created_at}</td>
                      <td className="px-4 py-3">
                        <button
                          onClick={() => handleRerun(project.configuration_name)}
                          className="px-2.5 py-0.5 text-xs font-medium text-blue-400 border border-blue-500/20 bg-blue-500/10 rounded-full hover:bg-blue-600/20 transition-colors"
                        >
                          Re-run
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={3} className="px-4 py-12 text-center">
                      <div className="flex flex-col items-center justify-center gap-3">
                        <svg className="w-10 h-10 text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                        </svg>
                        <p className="text-gray-500 text-sm">No configurations found.</p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default Datasets;
